import * as faker from 'faker';

import * as helpers from './helpers';
import {defaultOrgId} from './organizations';


export const shipments = {};
export const defaultShipmentId = 55323;
for (let id = defaultShipmentId; id < defaultShipmentId + 129; id++) {
    shipments[id] = {
        id: '' + id,

        carrierName: faker.company.companyName(),
        status: faker.random.arrayElement([
            'Saved',
            'Optimizing',
            'In Transit',
            'Delivered',
            'Cancelled',
            'Abandoned',
            'Exception',
        ]),
        direction: faker.random.arrayElement([
            'Inbound',
            'Outbound',
            'Drop',
            'Shuttle',
        ]),

        originPostalCode: faker.address.zipCode(),
        originCity: faker.address.city(),
        originLatitude: faker.address.latitude(),
        originLongitude: faker.address.longitude(),
        originState: faker.address.stateAbbr(),

        destinationPostalCode: faker.address.zipCode(),
        destinationCity: faker.address.city(),
        destinationLatitude: faker.address.latitude(),
        destinationLongitude: faker.address.longitude(),
        destinationState: faker.address.stateAbbr(),
    };
}

export const mocks = {
    ShipmentFile: () => {
        const fileTypeId = faker.random.arrayElement(['PDF', 'JPG', 'PNG', 'GIF', 'TIF']);
        return {
            orgId: defaultOrgId,
            //id
            //fileUploadId
            fileTypeId,
            uploadedFileName: faker.system.commonFileName(fileTypeId.toLowerCase()),
            //createdUtc:
            shipmentId: null,
            //shipmentDocumentTypeId
            originalFileDownloadUrlSas: '',
            previewImageDownloadUrlSas: '',
        }
    },
};

export const resolvers = {
    ShipmentQueries: {
        byId: (root, {id}) => shipments[id],
        all: () => Object.values(shipments),
        pagedQuery: helpers.pagedQuery(() => Object.values(shipments)),

        // drives the summary cards on the Dashboard
        count: (root, {}) => 42,
        byStatus: (root, {shipmentStatusId}) => {
            // must add up to count, above
            switch (shipmentStatusId) {
                case 'READY_TO_TENDER':
                    return 9;
                case 'WAITING_FOR_PICKUP':
                    return 4;
                case 'IN_TRANSIT':
                    return 18;
                case 'DELIVERED':
                    return 11;
                default:
                    return 0;
            }
        },
        byInTransitStatus: (root, {shipmentInTransitStatusId}) => {
            // must add up to IN_TRANSIT, above
            switch (shipmentInTransitStatusId) {
                case 'ON_TIME':
                    return 10;
                case 'OUT_FOR_DELIVERY':
                    return 5;
                case 'DELAYED':
                    return 3;
                default:
                    return 0;
            }
        },


        // drives the Shipments graph on the Dashboard
        pickedUpShipmentsGroupedByDateRangeType: (root, {dateRangeType, startDate, endDate}) => {
            let data = [];
            let date = startDate;
            while(date <= endDate) {
                let Key = null;
                if (dateRangeType === 'DAY_OF_WEEK') {
                    Key = date.format('ddd');
                    date.add(1, 'day');
                } else if (dateRangeType === 'WEEK') {
                    Key = date.format('MMM D');
                    date.add(1, 'week');
                } else if (dateRangeType === 'MONTH') {
                    Key = date.format('MMM');
                    date.add(1, 'month');
                } else if (dateRangeType === 'YEAR') {
                    Key = date.format('YYYY');
                    date.add(1, 'year');
                } else {
                    break;
                }

                data.push({
                    Key,
                    Value: faker.random.number({min: 12, max: 75}),
                });
            }

            return {
                dateRangeType,
                data,
            }
        },

        unassignedFiles: helpers.mockPagedQuery(15, mocks.ShipmentFile),
    },
};
